import { useMutation } from '@tanstack/react-query';
import { AxiosInstance } from 'axios';
import { useAxiosClientsContextProvider } from 'shared/axios/axios-clients-provider';

import { HandleEmergencyAlarmCommand } from '../models/update-emergency-alarm-status-command';

const emergencyAlarmBaseUrl = '/api/v1/EmergencyAlarm';

enum EmergencyAlarmQueryPaths {
  HandleEmergencyAlarm = 'HandleEmergencyAlarm',
}

const HandleEmergencyAlarm = async (axiosInstance: AxiosInstance, body: HandleEmergencyAlarmCommand): Promise<void> => {
  const response = await axiosInstance.put(`${emergencyAlarmBaseUrl}/${EmergencyAlarmQueryPaths.HandleEmergencyAlarm}`, body);
  return response.data;
};

export const useHandleEmergencyAlarm = () => {
  const { authenticatedInstance } = useAxiosClientsContextProvider();
  return useMutation({
    mutationKey: [EmergencyAlarmQueryPaths.HandleEmergencyAlarm],
    mutationFn: (body: HandleEmergencyAlarmCommand) => HandleEmergencyAlarm(authenticatedInstance, body),
  });
};
